export default {
    AUTH_USER: {
        SHOW: "/current-user/show",
    },
};
